import { useContext } from 'react';
import AppContext from '../../../App/AppContext';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import ReceiptIcon from '@material-ui/icons/Receipt';
import { AppStorage } from '../../../Core/Service/storage-service';

export const WorkShopComplaintButtons = ({ value, copyToClipboard, index, name, handleSuggestedTextModal }) => {
    const { portalSettings } = useContext(AppContext);
    const canAccessTextReWriter = AppStorage.getCanAccessTextReWriter();

    return (
        value && (
            <>
                <FileCopyIcon style={{ fontSize: '15px', cursor: 'pointer' }} onClick={() => copyToClipboard(value)} />
                {portalSettings.portalSettingEnableTextRewriter && canAccessTextReWriter && (
                    <ReceiptIcon
                        fontSize="small"
                        color="secondary"
                        onClick={() => handleSuggestedTextModal(value, index, name)}
                        style={{ fontSize: '15px', cursor: 'pointer' }}
                    />
                )}
            </>
        )
    );
};
